<template>
  <div class="logo" :class="classes">
    <img :alt="name" :src="src" />
  </div>
</template>

<script setup>
import customTeamLogos from '@/data/custom-team-logos.js'

const props = defineProps({ 
  name: String, 
  slug: String, 
  size: String,
  logo: String,
})

const cdnBase = useEnv('cdnBase')

const src = computed(() => customTeamLogos.includes(props.slug)
    ? `${cdnBase}/${props.slug}/${props.slug}-logo-${props.size}x${props.size}.png`
    : props.logo)

const classes = computed(() => [
    'size-' + props.size,
    (!customTeamLogos.includes(props.slug)
      ? 'not-custom'
      : '')
  ].join(' '))
</script>

<style scoped>
.logo.size-64.not-custom,
.logo.size-128.not-custom {
  @apply p-[0.25em];
}

.logo.size-256.not-custom,
.logo.size-512.not-custom {
  @apply p-[1em];
}

.logo img {
  @apply block;
}
</style>